import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { CenteredHeroWithModal } from "../components/CenteredHero/CenteredHeroWithModal";
import { DownloadLibraryNav } from "../components/DownloadLibraryNav";
import { DownloadLibraryProduct } from "../components/DownloadLibraryProduct";
import { DownloadLibrarySearchBlock } from "../components/DownloadLibrarySearchBlock";
import {
    firstBlockOverlapsNav,
    isOverlapBlockType,
} from "../components/HeaderNav/overlap";
import { PageSkeleton } from "../components/PageSkeleton";
import { toolboxComponents } from "../components/PageSkeleton/Toolbox";

export const Template = (
    props: templates.DownloadLibraryPageProductTemplate,
) => (
    <PageSkeleton
        {...props.page}
        overlapNav={firstBlockOverlapsNav(
            props.page.body.value.slice(0, 1).find(isOverlapBlockType),
        )}
    >
        <StreamField
            components={{
                ...toolboxComponents,
                centered_hero: CenteredHeroWithModal,
                download_library_search: ({ value }) => (
                    <DownloadLibrarySearchBlock
                        value={value}
                        autocomplete={props.autocomplete}
                        product={props.product}
                        productSummary={props.product_summary}
                    />
                ),
                download_library: () => (
                    <>
                        <DownloadLibraryNav
                            breadcrumbs={props.breadcrumbs}
                            autocomplete={props.autocomplete}
                        />
                        <DownloadLibraryProduct product={props.product} />
                    </>
                ),
            }}
            value={props.page.body.value}
            tagName={React.Fragment}
        />
    </PageSkeleton>
);
